import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { acknowledgeEvent } from './acknowledgeEvent';

import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';

export const useAcknowledgeEvent = (): UseMutationResult<
  unknown,
  Error,
  string,
  null
> => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationFn: (eventId: string) => {
        return acknowledgeEvent(olSession, eventId);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getPeriodEvents'] });
        queryClient.invalidateQueries({ queryKey: ['getCurrentEvents'] });
      },
    },
    'event:acknowledge',
  );
};
